export const getOffsetFromPageNumber = (pageNumber, limit) => limit * (pageNumber - 1);
export const getPageNumberFromOffset = (offset, limit) => offset / limit + 1;